module.exports = __webpack_public_path__ + "gdc.png";